

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface IPInvestigationParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface IPInvestigation {
    id?: any;
    tenantId: any;
    branchId: any;
    regId:any;
    visitId:any;
    testResult:string;
    notes:string;
    serviceId : any;
    physicianId:any;
    createdBy:string;
    createdDate:any;
    admissionId:number;
    orderedDateTime:any; 
    parameters?: IPInvestigationParameter[];
    links?: any;
}


export abstract class IPInvestigationData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<IPInvestigation[]>;
    abstract create(url: string, data: IPInvestigation): Observable<IPInvestigation[]>;
    abstract update(url: string, data: IPInvestigation): Observable<IPInvestigation>;
    abstract delete(url: string): Observable<any>;
}
